import { render, staticRenderFns } from "./VoteBoard.vue?vue&type=template&id=5c315549&scoped=true"
import script from "./VoteBoard.vue?vue&type=script&lang=js"
export * from "./VoteBoard.vue?vue&type=script&lang=js"
import style0 from "./VoteBoard.vue?vue&type=style&index=0&id=5c315549&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c315549",
  null
  
)

export default component.exports